import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN } from '@/store/mutation-types'

// 创建 axios 实例
const baseUrl = 'https://desktop.api.jgyljt.com/admin' // 正式
// const baseUrl = 'http://jgdesktop.test.jgyljt.com/admin' // 老测试
// const baseUrl = 'http://desktop-test.api.jgyljt.com/admin' // 测试

const service = axios.create({
  baseURL: baseUrl, // api base_url
  timeout: 6000 // 请求超时时间
})

const err = error => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    }
    if (error.response.status === 400) {
      notification.error({
        message: 'Forbidden',
        description: data.msg
      })
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
      if (token) {
        store.dispatch('Logout').then(() => {
          setTimeout(() => {
            window.location.reload()
          }, 1500)
        })
      }
    }
  }
  return Promise.reject(error)
}
// request interceptor
service.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
  config.transformRequest = [
    function(data) {
      let ret = ''
      for (const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }
  ]
  const token = Vue.ls.get(ACCESS_TOKEN)

  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  const roleList = Vue.ls.get('roleList') ? Vue.ls.get('roleList') : []
  const role = config.params !== undefined ? config.params.role : ''
  // console.log(111, config, roleList, role, roleList.lastIndexOf(role))
  if (roleList.length > 0) {
    if (role !== '' && roleList.lastIndexOf(role) < 0) {
      throw err({
        response: {
          status: 403,
          data: {
            message: '当前无可操作权限',
            msg: '当前无可操作权限',
            result: {}
          }
        }
      })
    } else if (role !== '' && roleList.lastIndexOf(role) > 0 && config.params.week === undefined) {
      delete config.params['role']
    }
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use(response => {
  return response.data
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export { installer as VueAxios, service as axios, baseUrl }
